import { CeoMessageComponent } from './components/company/ceo-message/ceo-message.component';
import { HistoryComponent } from './components/company/history/history.component';
import { OrganizationChartComponent } from './components/company/organization-chart/organization-chart.component';
import { CompanyIntroductionComponent } from './components/company/company-introduction/company-introduction.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { ko_KR } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import ko from '@angular/common/locales/ko';
import { CustomerRequestComponent } from './components/customer-service/customer-request/customer-request.component';
import { NzFormModule } from 'ng-zorro-antd/form';

import { NZ_ICONS } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(key => antDesignIcons[key])

import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { CompanyMainComponent } from './company-main/company-main.component';
import {NgZorroAntdModule} from 'ng-zorro-antd';
import {RndIntroductionComponent} from './components/teams/rnd-introduction/rnd-introduction.component';
import { MetalIntroductionComponent } from './components/teams/metal-introduction/metal-introduction/metal-introduction.component';
import { CompanyLocationComponent } from './components/company/company-location/company-location/company-location.component';
import { SemiIntroductionComponent } from './components/teams/semi-introduction/semi-introduction.component';


registerLocaleData(ko);

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    CompanyIntroductionComponent,
    CustomerRequestComponent,
    CompanyMainComponent,
    OrganizationChartComponent,
    HistoryComponent,
    CeoMessageComponent,
    RndIntroductionComponent,
    MetalIntroductionComponent,
    CompanyLocationComponent,
    SemiIntroductionComponent
  ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NzFormModule,
        NzGridModule,
        NzMenuModule,
        NgZorroAntdModule
    ],
  providers: [{ provide: NZ_I18N, useValue: ko_KR }, { provide: NZ_ICONS, useValue: icons }],
  bootstrap: [AppComponent]
})
export class AppModule { }
